var EcomMessageSender = /** @class */ (function () {
    function EcomMessageSender(targetOrigin) {
        this.targetOrigin = targetOrigin;
    }
    EcomMessageSender.create = function (targetOrigin) {
        return new EcomMessageSender(targetOrigin);
    };
    EcomMessageSender.prototype.sendMessage = function (message) {
        window.parent.postMessage(message, this.targetOrigin);
    };
    return EcomMessageSender;
}());
export { EcomMessageSender };
